__turbopack_context__.v({
  "gift-message-span": "styles-module__pAzGoq__gift-message-span",
  "image": "styles-module__pAzGoq__image",
  "radio-wrapper": "styles-module__pAzGoq__radio-wrapper",
});
